import { render, staticRenderFns } from "./OpportunitySubmissionForm.vue?vue&type=template&id=1c52d118&"
import script from "./OpportunitySubmissionForm.vue?vue&type=script&lang=js&"
export * from "./OpportunitySubmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitySubmissionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports